import { ModalContextProvider } from 'utils/contexts/modal';

import { FacebookLoginContextProvider } from './contexts/FacebookLoginContextProvider';
import { FacebookIntegrationsContextProvider } from './contexts/FacebookIntegrationContextProvider';
import { AdAccountContextProvider } from './contexts/AdAccountContextProvider';
import { SelectAdAccountPage } from './components/selectPage/SelectAdAccountPage';

export const SelectAdAccounts = () => {
  return (
    <ModalContextProvider>
      <FacebookLoginContextProvider>
        <AdAccountContextProvider>
          <FacebookIntegrationsContextProvider>
            <SelectAdAccountPage />
          </FacebookIntegrationsContextProvider>
        </AdAccountContextProvider>
      </FacebookLoginContextProvider>
    </ModalContextProvider>
  );
};
